import { css } from '@/styled-system/css';

export const comboboxLoadingStateStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBlock: 'tight',
  paddingInline: 'default',
});
